@if (data.properties) {
    <mat-tab-group class="hjalp-tab-group fade-in-left" [animationDuration]="'0'">
        @for (property of data.properties; track property.id) {
            <mat-tab [label]="property.propertyNumber">
                <ng-template matTabContent>
                    @if (propertyDataMap[property.id]; as propertyData) {
                        <div class="flex w-100 gap-2 items-center">
                            <span class="whitespace-nowrap h-auto"> {{ 'label_data_fetched_at' | translate }}: </span>

                            <mat-form-field class="grow max-w-60">
                                <mat-select
                                    [placeholder]="'label_select' | translate"
                                    [(value)]="propertyData.selectedDocument"
                                    (selectionChange)="onDocumentChanged(property.id)"
                                >
                                    @for (option of propertyData.documentOptions; track option.value) {
                                        <mat-option [value]="option.value">
                                            {{ option.label }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            <button
                                class="w-32"
                                mat-flat-button
                                type="button"
                                color="primary"
                                [disabled]="propertyData.loading || !propertyData.pdfSrc"
                                (click)="downloadDocument(property.id)"
                            >
                                <mat-icon class="icon-size-5 mr-1" fontIcon="download"></mat-icon>
                                {{ 'label_download' | translate }}
                            </button>
                        </div>

                        <mat-divider class="my-4"></mat-divider>

                        @if (propertyData.loading) {
                            <div class="flex items-center gap-2 p-4">
                                <mat-progress-spinner [diameter]="20" mode="indeterminate"></mat-progress-spinner>
                                {{ 'label_fetching_document' | translate }}
                            </div>
                        } @else if (propertyData.error) {
                            <div class="p-4">
                                <p>{{ 'error_fetching_displaying_document' | translate }}</p>

                                <button mat-stroked-button color="primary" type="button" (click)="retryDocument(property.id)">
                                    {{ 'label_try_again' | translate }}
                                </button>
                            </div>
                        } @else if (propertyData.pdfSrc) {
                            <pdf-viewer
                                class="block overflow-y-auto overflow-x-hidden"
                                [src]="propertyData.pdfSrc"
                                [rotation]="0"
                                [original-size]="false"
                                [autoresize]="true"
                                (error)="onPdfError(property.id)"
                                style="width: 100%; height: 1100px; max-width: 900px"
                            ></pdf-viewer>
                        }
                    } @else {
                        {{ noDataLabel | translate }}
                    }
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>
}
